/**
 * Product navigation: level1 (main) → sub1 (level 2) → sub2 (level 3 links).
 */

export const PRODUCT_NAV_SECTIONS = [
  {
    id: "kitchen",
    title: "لوازم آشپزخانه",
    href: "/kitchen",
    description: "لوازم هوشمند آشپزخانه",
    sub1: [
      {
        title: "سطل آشپزخانه",
        href: "/kitchen/سطل-آشپزخانه",
        sub2: [
          { title: "سطل پدالی", href: "/kitchen/سطل-پدالی", slug: "سطل-پدالی" },
          {
            title: "سطل رو کابینتی",
            href: "/kitchen/سطل-رو-کابینتی",
            slug: "سطل-رو-کابینتی",
          },
          {
            title: "سطل هوشمند",
            href: "/kitchen/سطل-هوشمند",
            slug: "سطل-هوشمند",
          },
        ],
      },
      {
        title: "جا ظرفی - آبچکان",
        href: "/kitchen/جاظرفی",
        sub2: [],
      },
      {
        title: "جا مایع ظرفشویی",
        href: "/kitchen/جامایع-ظرفشویی",
        sub2: [
          {
            title: "جا مایع اسکاج",
            href: "/kitchen/جامایع-اسکاج",
            categorySlug: "جامایع-ظرفشویی",
          },
        ],
      },
    ],
  },
  {
    id: "toilet",
    title: "سرویس بهداشتی",
    href: "/toilet",
    sub1: [
      {
        title: "سطل برس",
        href: "/toilet/سطل-برس",
        sub2: [{ title: "دیواری", href: "/toilet/سطل-برس-دیواری" }],
      },
      {
        title: "جا دستمال",
              href: "/toilet/جادستمال",
        sub2: [
          {
            title: "رولی",
            href: "/toilet/رولی",
            categorySlug: "جادستمال",
          },
        ],
      },
      {
        title: "ست رومیزی",
        href: "/toilet/ست-رومیزی",
        slug: "ست-رومیزی",
        sub2: [],
      },
      {
        title: "سرویس دیواری",
        href: "/toilet/سرویس-دیواری",
        slug: "سرویس-دیواری",
        sub2: [
          {
            title: "چسبی",
            href: "/toilet/سرویس-دیواری-چسبی",
            slug: "سرویس-دیواری-چسبی",
          },
          {
            title: "نصبی",
            href: "/toilet/سرویس-دیواری-نصبی",
            slug: "سرویس-دیواری-نصبی",
          },
        ],
      },
      {
        title: "جا مایع",
        href: "/toilet/جامایع",
        sub2: [
          {
            title: "چشمی",
            href: "/toilet/جامایع-چشمی",
          },
        ],
      },
      {
        title: "جا مسواک",
        href: "/toilet/جامسواکی",
        sub2: [
          {
            title: "آنتی باکتریال",
            href: "/toilet/جامسواکی-آنتی-باکتریال",
          },
        ],
      },
      {
        title: "استند ایستاده دستمال و برس",
        href: "/toilet/استند-ایستاده-دستمال",
        slug: "استند-ایستاده-دستمال",
        sub2: [],
      },
    ],
  },
  {
    id: "bathroom",
    title: "حمام",
    href: "/bathroom",
    sub1: [
      {
        title: "جا شامپو - استند حمام",
         href: "/bathroom/جاشامپو",
        sub2: [
         
        ],
      },
      {
        title: "رخت آویز",
       href: "/bathroom/رخت-آویز"
      },
    ],
  },
  {
    id: "accessory",
    title: "اکسسوری منزل",
    href: "/accessory",
    sub1: [
      {
        title: "رول و حوله رومیزی",
        href: "/accessory/حوله-رومیزی",
        slug: "حوله-رومیزی",
      },
      {
        title: "دست خشک کن",
        href: "/accessory/دست-خشک-کن",
        slug: "دست-خشک-کن",
      },
      {
        title: "آینه اصلاح آرایشی",
        href: "/accessory/آينه-اصلاح",
        slug: "آينه-اصلاح",
      },
      {
        title: "سطل کوچک",
        href: "/accessory/سطل-سرویس",
        slug: "سطل-سرویس",
      },
      {
        title: "طی",
        href: "/accessory/طی",
        slug: "طی",
      },
    ],
  },
];

const SECTION_IDS = new Set(PRODUCT_NAV_SECTIONS.map((section) => section.id));

function getHrefSlug(href) {
  if (!href) return null;
  const segments = href.split("/").filter(Boolean);
  return segments[segments.length - 1] || null;
}

function getSub1Key(sectionId, index) {
  return `${sectionId}-sub1-${index}`;
}

/** @param {{ id: string, sub1?: Array<object> }} section */
export function getSectionSub1List(section) {
  return (section.sub1 || []).map((entry, index) => ({
    ...entry,
    key: getSub1Key(section.id, index),
  }));
}

/** @param {string} sectionId */
export function getProductNavSection(sectionId) {
  return (
    PRODUCT_NAV_SECTIONS.find((section) => section.id === sectionId) ?? null
  );
}

/** @param {string} sectionId @param {string} slug */
export function getProductNavSubcategory(sectionId, slug) {
  const section = getProductNavSection(sectionId);
  if (!section) return null;

  for (const sub1 of section.sub1 || []) {
    const sub1HrefSlug = getHrefSlug(sub1.href);
    if ((sub1.slug === slug || sub1HrefSlug === slug) && sub1.href) {
      return { section, sub1, item: sub1 };
    }

    const sub2Item = (sub1.sub2 || []).find(
      (entry) => entry.slug === slug || getHrefSlug(entry.href) === slug
    );
    if (sub2Item) {
      return { section, sub1, item: sub2Item };
    }
  }

  return null;
}

/** Map a nav URL segment to the API category slug used for filtering. */
export function getProductNavCategorySlug(sectionId, pathSlug) {
  if (!pathSlug) return pathSlug;
  if (!isProductNavSection(sectionId)) return pathSlug;
  if (sectionId === pathSlug) return sectionId;

  const match = getProductNavSubcategory(sectionId, pathSlug);
  if (!match?.item) return pathSlug;

  return (
    match.item.categorySlug ||
    match.item.slug ||
    getHrefSlug(match.item.href) ||
    pathSlug
  );
}

/** Nav label for a subcategory URL segment (when API category title differs). */
export function getProductNavPageTitle(sectionId, pathSlug) {
  return getProductNavSubcategory(sectionId, pathSlug)?.item?.title || null;
}

/** @param {string} sectionId */
export function isProductNavSection(sectionId) {
  return SECTION_IDS.has(sectionId);
}

/**
 * Breadcrumb trail for product nav URLs (/kitchen, /kitchen/slug, …).
 * @param {string} pathname
 * @returns {Array<{ label: string, href: string }>|null}
 */
export function getProductNavBreadcrumbItems(pathname) {
  if (!pathname || pathname === "/") return null;

  const segments = pathname.split("/").filter(Boolean);
  const sectionId = segments[0];
  if (!isProductNavSection(sectionId)) return null;

  const section = getProductNavSection(sectionId);
  if (!section) return null;

  const items = [
    { label: "خانه", href: "/" },
    { label: section.title, href: section.href },
  ];

  const pathSlug = segments[1];
  if (!pathSlug) return items;

  const match = getProductNavSubcategory(sectionId, decodeURIComponent(pathSlug));
  if (!match?.item?.href) return items;

  if (match.item !== match.sub1 && match.sub1?.href) {
    items.push({ label: match.sub1.title, href: match.sub1.href });
  }

  items.push({ label: match.item.title, href: match.item.href });
  return items;
}

/**
 * Breadcrumb trail for /category/[slug] when the API slug maps to product nav.
 * @param {string} categorySlug
 * @returns {Array<{ label: string, href: string }>|null}
 */
export function getCategoryNavBreadcrumbItems(categorySlug) {
  if (!categorySlug) return null;

  for (const section of PRODUCT_NAV_SECTIONS) {
    if (section.id === categorySlug) {
      return [
        { label: "خانه", href: "/" },
        { label: section.title, href: section.href },
      ];
    }

    for (const sub1 of section.sub1 || []) {
      const sub1HrefSlug = getHrefSlug(sub1.href);
      const sub1ApiSlug = getProductNavCategorySlug(section.id, sub1HrefSlug);

      if (sub1ApiSlug === categorySlug || sub1HrefSlug === categorySlug) {
        const items = [
          { label: "خانه", href: "/" },
          { label: section.title, href: section.href },
        ];
        if (sub1.href) {
          items.push({ label: sub1.title, href: sub1.href });
        }
        return items;
      }

      for (const sub2 of sub1.sub2 || []) {
        const sub2HrefSlug = getHrefSlug(sub2.href);
        const sub2ApiSlug = getProductNavCategorySlug(section.id, sub2HrefSlug);

        if (
          sub2ApiSlug === categorySlug ||
          sub2.slug === categorySlug ||
          sub2HrefSlug === categorySlug
        ) {
          const items = [
            { label: "خانه", href: "/" },
            { label: section.title, href: section.href },
          ];
          if (sub1.href) {
            items.push({ label: sub1.title, href: sub1.href });
          }
          if (sub2.href) {
            items.push({ label: sub2.title, href: sub2.href });
          }
          return items;
        }
      }
    }
  }

  return null;
}

/** Prefer product-nav href for a category API slug, else /category/slug. */
export function getCategoryHref(categorySlug) {
  if (!categorySlug) return "/product";

  const navItems = getCategoryNavBreadcrumbItems(categorySlug);
  if (navItems?.length) {
    return navItems[navItems.length - 1].href;
  }

  return `/category/${categorySlug}`;
}

export function getAllProductNavPaths() {
  const paths = [];

  for (const section of PRODUCT_NAV_SECTIONS) {
    paths.push({ section: section.id, slug: null });

    for (const sub1 of section.sub1 || []) {
      if (sub1.slug && sub1.href) {
        paths.push({ section: section.id, slug: sub1.slug });
      }
      for (const sub2 of sub1.sub2 || []) {
        paths.push({ section: section.id, slug: sub2.slug });
      }
    }
  }

  return paths;
}

/**
 * Flat crawlable mega-menu links (section → sub1 → sub2).
 * @returns {Array<{ href: string, title: string }>}
 */
export function getProductNavLinkEntries() {
  /** @type {Array<{ href: string, title: string }>} */
  const links = [];
  const seen = new Set();

  const push = (href, title) => {
    if (!href || seen.has(href)) return;
    seen.add(href);
    links.push({ href, title: title || href });
  };

  push("/categories", "دسته‌بندی محصولات");

  for (const section of PRODUCT_NAV_SECTIONS) {
    push(section.href, section.title);

    for (const sub1 of section.sub1 || []) {
      push(sub1.href, sub1.title);

      for (const sub2 of sub1.sub2 || []) {
        push(sub2.href, sub2.title);
      }
    }
  }

  return links;
}
